import L from "leaflet";

function svgMarkerDataURL(fillColor) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 41">
      <path
        d="M12,2
           C8.69,2 6,4.69 6,8
           c0,4.34 6,12 6,12
           s6,-7.66 6,-12
           C18,4.69 15.31,2 12,2
           z"
        fill="${fillColor}"
      />
      <circle
        cx="12"
        cy="10"
        r="2.5"
        fill="#fff"
      />
    </svg>
  `.trim();

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

export const pinkIcon = new L.Icon({
  iconUrl: svgMarkerDataURL("#E578FF"),
  iconSize: [48, 82],
  iconAnchor: [24, 42],
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
  shadowSize: [30, 30],
  shadowAnchor:[15, 30],
});

export const blueIcon = new L.Icon({
  iconUrl: svgMarkerDataURL("#007bff"),
  iconSize: [42, 82],
  iconAnchor: [24, 42],
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
  shadowSize: [30, 30],
  shadowAnchor:[15, 30],
});

export const greyIcon = new L.Icon({
  iconUrl: svgMarkerDataURL("#696969"),
  iconSize: [42, 82],
  iconAnchor: [24, 42],
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
  shadowSize: [30, 30],
  shadowAnchor:[15, 30],
})